<template>
  <b-modal
    id="modal-center"
    centered
    scrollable
    hide-footer
    :title="value.title"
    footer-text-variant="footerTextVariant"
  >
    <img
      v-bind:src="value.summary.thumb"
      v-bind:alt="value.title"
      class="card-img-top"
    />
    <p>{{ value.summary.text }}</p>
    <ul>
      <li v-for="item in value.links" :key="item.title">
        <a :href="item.href" target="_blank">{{ item.title }}</a>
      </li>
    </ul>
  </b-modal>

  <!-- <b-modal id="modal-center">
    <template #modal-header="{ close }">
      <b-button size="sm" variant="outline-danger" @click="close()">
        Close Modal
      </b-button>
      <h5>Modal Header</h5>
    </template>

    <template #default="{ hide }">
      <p>Modal Body with button</p>
      <b-button @click="hide()">Hide Modal</b-button>
    </template>

    <template #modal-footer="{ ok, cancel, hide }">
      <b>Custom Footer</b>
      <b-button size="sm" variant="success" @click="ok()">
        OK
      </b-button>
      <b-button size="sm" variant="danger" @click="cancel()">
        Cancel
      </b-button>
      <b-button size="sm" variant="outline-secondary" @click="hide('forget')">
        Forget it
      </b-button>
    </template>
  </b-modal> -->
</template>

<script>
export default {
  name: 'Modal',
  props: ['value'],
};
</script>
